<ng-container *ngIf="showCommentsModal">
  <div class="neptune-modal-cover">
    <div
      id="full-comments-modal"
      class="w-[25vw] max-h-[50vh] flex flex-col p-9 gap-6 overflow-auto bg-white"
    >
      <section
        id="full-comments-header"
        class="flex justify-between pb-2 neptune-border-b-2 border-sky-blue"
      >
        <span class="text-2xl">Full Comments</span>
        <img
          src="/assets/shared-icons/neptune-icon-blue-close.svg"
          alt="Close"
          (click)="closeCommentsModal()"
          class="h-6 w-6 self-center"
        />
      </section>
      <section id="full-comments-body">
        <p class="full-comments-modal-text">
          {{ commentsModalText }}
        </p>
      </section>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="showParticipantsModal">
  <div class="neptune-modal-cover">
    <div
      id="participant-names-modal"
      class="w-[25vw] max-w-96 max-h-[50vh] flex flex-col p-9 gap-6 overflow-auto bg-white"
    >
      <section
        id="participant-names-header"
        class="flex justify-between pb-2 neptune-border-b-2 border-sky-blue"
      >
        <span class="text-2xl">Training Participants</span>
        <img
          src="/assets/shared-icons/neptune-icon-blue-close.svg"
          alt="Close"
          (click)="closeParticipantsModal()"
          class="h-6 w-6 self-center"
        />
      </section>
      <section id="participant-names-body">
        <ul
          id="participants-list"
          class="list-decimal pl-5"
          *ngIf="participantNameList.length > 0"
        >
          <li *ngFor="let participant of participantNameList">
            {{ participant }}
          </li>
        </ul>
        <p
          *ngIf="participantNameList.length === 0"
          class="participants-modal-text"
        >
          No participant names recorded.
        </p>
      </section>
    </div>
  </div>
</ng-container>

<service-insights-photo-gallery
  *ngIf="isExportPhotoView"
></service-insights-photo-gallery>

<section
    id="service-details-table"
    class="flex flex-col w-full box-border p-6 gap-6 mb-neptune-bar"
  >
    <service-details-kpi-cards></service-details-kpi-cards>

    <ng-container *ngIf="groupByValue === 'issues'">
      <service-details-issues-filter
        (issueFilterSelected)="handleIssueFilterSelected($event)"
        [title]="title"
        [data]="byIssuesData"
      >
      </service-details-issues-filter>
    </ng-container>

    <ng-container *ngIf="!isToolbarLoading; else skeletonLoaderToolbar">
      <!--
        TODO: Extract the toolbar into a standalone component after state management is centralized
        (e.g., via a store). In the current implementation, the toolbar depends on multiple pieces
        of parent-owned state and callbacks (pagination, expand/collapse, advanced filters), and
        extracting it now would introduce significant prop-drilling and increase component coupling.
        -->
      <section id="service-details-toolbar" class="flex flex-col gap-2">
        <div class="flex justify-between items-center">
          <div class="flex items-center">
            <section id="service-details-table-view-controls">
              <button
                class="min-w-[150px] flex justify-between items-center"
                aria-label="expand rows"
                (click)="toggleAll(!areAllRowsCollapsed)"
                [ngClass]="
                  areAllRowsCollapsed
                    ? 'neptune-button-white'
                    : 'neptune-button-blue'
                "
              >
                {{ areAllRowsCollapsed ? "Expand All" : "Collapse All" }}

                <img
                  src="{{
                    areAllRowsCollapsed
                      ? '/assets/shared-icons/neptune-icon-blue-expand.svg'
                      : '/assets/shared-icons/neptune-icon-white-collapse.svg'
                  }}"
                  alt="{{ areAllRowsCollapsed ? 'Expand All' : 'Collapse All' }}"
                />
              </button>
            </section>
            <advanced-filters
            [advancedFilterData]="advancedFilterData"
            [excludeKeys]="excludeKeys"
            [pageScope]="'Service Details'"
            [selectedAdvancedFilters]="selectedAdvancedFilters"
            (selectedFilters)="onSelectedFiltersChange($event)"
            [(toggleBody)]="toggleAdvancedFilterSelection"
            [useRefreshedUi]="true"
            >
            </advanced-filters>
          </div>

          <div id="paginator-container">
            <paginator
              [currentPage]="currentPage + 1"
              [totalItems]="totalRows"
              [limit]="pageSize"
              [pageSizeOptions]="pageSizeOptions"
              (pageChange)="onPageChange($event)"
            >
            </paginator>
          </div>
        </div>
        <div
          id="service-details-advanced-filters"
          class="neptune-advanced-filters"
        >
          <advanced-filters-selection
            [advancedFilterData]="advancedFilterData"
            [excludeKeys]="excludeKeys"
            [pageScope]="'Service Details'"
            [selectedAdvancedFilters]="selectedAdvancedFilters"
            (selectedFilters)="onSelectedFiltersChange($event)"
            [(toggleBody)]="toggleAdvancedFilterSelection"
          >
          </advanced-filters-selection>

        </div>
      </section>
    </ng-container>

    <ng-container *ngIf="!showExpandedTableLoader; else skeletonLoaderTable">
      <section id="service-details-rows" class="flex flex-col gap-1">
        <ng-container *ngIf="!noDataAvailable; else noData">
          <div *ngFor="let group of groupedResult; let i = index">
            <!-- Grouped collapsible heading -->
            <section
              class="group-header flex justify-start items-center w-full box-border border-solid border-1 p-4 gap-2 rounded-lg border-sky-blue bg-neptune-color-primary-50 text-blue"
            >
              <span class="grouping">
                {{
                  groupByValue === "endDate"
                    ? (group.key | date: "longDate")
                    : group.key
                }}
                ({{ group.items.length }})
              </span>
              <button
                aria-label="expand row"
                (click)="toggle(i)"
                class="bg-transparent flex !p-0"
              >
                <img
                  src="/assets/shared-icons/neptune-icon-blue-chevron-down.svg"
                  [alt]="hideRuleContent[i] ? 'Expand Row' : 'Collapse Row'"
                  class="transition-all duration-300"
                  [ngClass]="{
                    'rotate-180': !hideRuleContent[i],
                  }"
                />
              </button>
            </section>
            <ng-container *ngIf="!hideRuleContent[i]">
              <div
                *ngFor="let item of group.items; let j = index"
                id="{{ item.workOrderId }}-{{ groupByValue }}"
              >
                <ng-container [ngSwitch]="callType">
                  <ng-container
                    *ngSwitchCase="SICallTypes.RegularServiceCalls"
                    [ngTemplateOutlet]="regularServiceCallsAndProgramReviews"
                    [ngTemplateOutletContext]="{ item: item }"
                  ></ng-container>

                  <ng-container
                    *ngSwitchCase="SICallTypes.Installations"
                    [ngTemplateOutlet]="installations"
                    [ngTemplateOutletContext]="{ item: item }"
                  ></ng-container>

                  <ng-container
                    *ngSwitchCase="SICallTypes.ExtraServiceVisit"
                    [ngTemplateOutlet]="extraServiceVisits"
                    [ngTemplateOutletContext]="{ item: item }"
                  ></ng-container>

                  <ng-container
                    *ngSwitchCase="SICallTypes.ProgramReviews"
                    [ngTemplateOutlet]="regularServiceCallsAndProgramReviews"
                    [ngTemplateOutletContext]="{ item: item }"
                  ></ng-container>

                  <ng-container
                    *ngSwitchCase="SICallTypes.TrainingSessions"
                    [ngTemplateOutlet]="trainingSessions"
                    [ngTemplateOutletContext]="{ item: item }"
                  ></ng-container>

                  <ng-container
                    *ngSwitchCase="SICallTypes.QuickCalls"
                    [ngTemplateOutlet]="quickCalls"
                    [ngTemplateOutletContext]="{ item: item }"
                  ></ng-container>

                  <ng-container
                    *ngSwitchCase="SICallTypes.Audit"
                    [ngTemplateOutlet]="audit"
                    [ngTemplateOutletContext]="{ item: item }"
                  ></ng-container>

                  <ng-container
                    *ngSwitchCase="SICallTypes.VirtualAssistCalls"
                    [ngTemplateOutlet]="virtualAssistCalls"
                    [ngTemplateOutletContext]="{ item: item }"
                  ></ng-container>
                </ng-container>
              </div>
            </ng-container>
          </div>
        </ng-container>

        <ng-template #noData>
          <div class="no-data">No Data Available</div>
        </ng-template>
      </section>
    </ng-container>
  </section>

<!--
  Templates for individual service call types.

  Rationale:
  - Each call type has distinct business-specific content and layout requirements.
  - Keeping templates separate makes each service call experience easier to
    understand and modify in isolation.
  - Avoids introducing large conditional/if-else or switch-based rendering
    logic within a single template.
  - Deliberately not split into Angular components to avoid additional
    coupling, prop drilling, and component overhead for view-only fragments.
    This might change in the future if we implement a central store for managing
    service call data and control hiding of UI fragments.
  - Verbatim layouts and UI fragments shared across call types are defined
    in the reusable template section below.

  Template consolidation rule of thumb:
  - 1 small conditional fragment -> merge. (Program Reviews and Regular Service Calls)
  - 2-3 unrelated conditional regions -> probably keep separate, weigh pros and cons.
  - Repeated call-type checks scattered throughout a template -> keep separate.

  Identified blockers to migrating templates into individual components:
  - UI state is owned and managed locally within this component (for example, hide/expand state), creating tight coupling between templates and component implementation details.
  - Rendering of service-call-specific UI fragments depends on component-level state and contextual logic (for example, isEMS, hideRuleContent, isRowExpanded, toggleArrow).
  - User interactions and supporting behaviors (for example, telemetry, navigation, and utility methods such as trackMixpanelEvent and getWorkOrderUrl) are implemented within this component and rely on its internal state and context.

  Future direction:
  - Move service call data and UI state into a centralized store.
  - Extract reusable checks, utility functions, navigation, and telemetry concerns into dedicated services/facades.
  - Once state and behavioral dependencies are externalized, service-call-specific views can be promoted to standalone presentational components with well-defined inputs and outputs.
-->
<ng-template #regularServiceCallsAndProgramReviews let-item="item">
  <section class="collapsed-section flex w-full box-border min-h-14 max-h-fit">
    <ng-container
      *ngTemplateOutlet="serviceStatus; context: { item: item }"
    ></ng-container>

    <ng-container
      *ngTemplateOutlet="locationInformation; context: { item: item }"
    >
    </ng-container>

    <section class="service-details collapsed-item gap-1 w-[15%]">
      <div class="flex items-center gap-2">
        <span class="service-label">
          {{ callType | serviceCallTypeLabel }}
          <span *ngIf="isEMS(item)">&nbsp;(EMS)</span>
        </span>

        <img
          *ngIf="item.recurringIssues > 0"
          src="assets/service-insights/neptune-icon-black-recurring.svg"
          alt="Recurring Issue Icon"
        />

        <img
          *ngIf="item.virtualVisit > 0"
          src="assets/service-insights/neptune-icon-black-virtual-visit.svg"
          alt="Virtual Visit Icon"
        />
      </div>

      <div
        class="comments text-xs line-clamp-3"
        *ngIf="callType === SICallTypes.ProgramReviews"
      >
        <p>{{ item.callSummaryNotes }}</p>
      </div>

      <div
        class="flex items-center text-xs"
        *ngIf="!isEMS(item)"
        (click)="trackMixpanelEvent('See Notes')"
      >
        <a
          target="_blank"
          [href]="getWorkOrderUrl(item?.workOrderId)"
          class="flex items-center text-blue font-bold"
        >
          See Notes
          <img
            src="assets/shared-icons/neptune-icon-blue-chevron-right.svg"
            alt="See Notes"
            class="w-[14px] h-[14px]"
          />
        </a>
      </div>
    </section>

    <ng-container
      *ngTemplateOutlet="findingsBox; context: { item: item }"
    ></ng-container>

    <ng-container
      *ngTemplateOutlet="photoThumbnails; context: { item: item }"
    ></ng-container>

    <ng-container *ngTemplateOutlet="infoToggle; context: { item: item }">
    </ng-container>
  </section>

  <section
    class="expanded-section w-full box-border p-6 flex justify-between bg-neptune-color-neutral-300 transition-all duration-300 ease-in-out"
    *ngIf="isRowExpanded(item.id)"
  >
    <ng-container
      *ngTemplateOutlet="accountInformation; context: { item: item }"
    >
    </ng-container>

    <section
      class="findings comments flex flex-col justify-start items-center w-[30%]"
    >
      <ng-container
        *ngTemplateOutlet="generalObservations; context: { item: item }"
      >
      </ng-container>

      <ng-container
        *ngTemplateOutlet="specificObservations; context: { item: item }"
      >
      </ng-container>

      <ng-container
        *ngTemplateOutlet="fullCommentsInReport; context: { item: item }"
      >
      </ng-container>
    </section>

    <ng-container *ngTemplateOutlet="workOrderDetails; context: { item: item }">
    </ng-container>
  </section>
</ng-template>

<ng-template #installations let-item="item">
  <section class="collapsed-section flex w-full box-border min-h-14 max-h-fit">
    <ng-container
      *ngTemplateOutlet="serviceStatus; context: { item: item }"
    ></ng-container>

    <ng-container
      *ngTemplateOutlet="locationInformation; context: { item: item }"
    >
    </ng-container>

    <section class="service-details collapsed-item gap-1 w-[15%]">
      <div class="flex items-center gap-2">
        <span class="service-label">
          {{ callType | serviceCallTypeLabel }}
          <span *ngIf="isEMS(item)">&nbsp;(EMS)</span>
        </span>

        <img
          *ngIf="item.recurringIssues > 0"
          src="assets/service-insights/neptune-icon-black-recurring.svg"
          alt="Recurring Issue Icon"
        />

        <img
          *ngIf="item.virtualVisit"
          src="assets/service-insights/neptune-icon-black-virtual-visit.svg"
          alt="Virtual Visit Icon"
        />
      </div>

      <ul class="equipment-info mt-0 pl-5 text-xs">
        <li class="equipment-type">{{ item.equipmentLocation }}</li>
        <li class="equipment-location">{{ item.equipmentType }}</li>
      </ul>

      <div
        class="flex items-center text-xs"
        *ngIf="!isEMS(item)"
        (click)="trackMixpanelEvent('See Notes')"
      >
        <a
          target="_blank"
          [href]="getWorkOrderUrl(item?.workOrderId)"
          class="flex items-center text-blue font-bold"
        >
          See Notes
          <img
            src="assets/shared-icons/neptune-icon-blue-chevron-right.svg"
            alt="See Notes"
            class="w-[14px] h-[14px]"
          />
        </a>
      </div>
    </section>

    <ng-container
      *ngTemplateOutlet="photoThumbnails; context: { item: item }"
    ></ng-container>

    <ng-container *ngTemplateOutlet="infoToggle; context: { item: item }">
    </ng-container>
  </section>

  <section
    class="expanded-section w-full box-border p-6 flex justify-between bg-neptune-color-neutral-300 transition-all duration-300 ease-in-out"
    *ngIf="isRowExpanded(item.id)"
  >
    <ng-container
      *ngTemplateOutlet="accountInformation; context: { item: item }"
    >
    </ng-container>

    <section
      class="comments flex flex-col justify-start items-center gap-2 w-[30%]"
    >
      <div class="comment-section flex flex-col justify-start items-start">
        <span class="comment-title text-sm font-bold">Comments</span>
        <p class="comment-content text-sm line-clamp-4">
          {{ item.installationCallComments }}
        </p>
      </div>

      <ng-container
        *ngTemplateOutlet="fullCommentsInReport; context: { item: item }"
      ></ng-container>
    </section>

    <ng-container *ngTemplateOutlet="workOrderDetails; context: { item: item }">
    </ng-container>
  </section>
</ng-template>

<ng-template #extraServiceVisits let-item="item">
  <section class="collapsed-section flex w-full box-border min-h-14 max-h-fit">
    <ng-container
      *ngTemplateOutlet="serviceStatus; context: { item: item }"
    ></ng-container>

    <ng-container
      *ngTemplateOutlet="locationInformation; context: { item: item }"
    >
    </ng-container>

    <section class="service-details collapsed-item gap-1 w-[15%]">
      <div class="flex items-center gap-2">
        <span class="service-label">
          {{ callType | serviceCallTypeLabel }}
          <span *ngIf="isEMS(item)">&nbsp;(EMS)</span>
        </span>
                <!-- here -->

        <img
          *ngIf="item.recurringIssues > 0"
          src="assets/service-insights/neptune-icon-black-recurring.svg"
          alt="Recurring Issue Icon"
        />

        <img
          *ngIf="item.virtualVisit"
          src="assets/service-insights/neptune-icon-black-virtual-visit.svg"
          alt="Virtual Visit Icon"
        />
      </div>

      <div
        class="flex items-center text-xs"
        *ngIf="!isEMS(item)"
        (click)="trackMixpanelEvent('See Notes')"
      >
        <a
          target="_blank"
          [href]="getWorkOrderUrl(item?.workOrderId)"
          class="flex items-center text-blue font-bold"
        >
          See Notes
          <img
            src="assets/shared-icons/neptune-icon-blue-chevron-right.svg"
            alt="See Notes"
            class="w-[14px] h-[14px]"
          />
        </a>
      </div>
    </section>

    <ng-container
      *ngTemplateOutlet="photoThumbnails; context: { item: item }"
    ></ng-container>

    <ng-container *ngTemplateOutlet="infoToggle; context: { item: item }">
    </ng-container>
  </section>

  <section
    class="expanded-section w-full box-border p-6 flex justify-between bg-neptune-color-neutral-300 transition-all duration-300 ease-in-out"
    *ngIf="isRowExpanded(item.id)"
  >
    <ng-container
      *ngTemplateOutlet="accountInformation; context: { item: item }"
    >
    </ng-container>

    <section
      class="findings comments flex flex-col justify-start items-center w-[30%]"
    >
      <section class="comments-section text-sm self-start">
        <span class="comments-title font-bold">Comments:</span>
        <p class="comments-content text-sm line-clamp-4">
          {{ item.esrCallComments ?? "N/A" }}
        </p>
        <div
          *ngIf="isEMS(item) && item.esrCallComments"
          class="full-comments-link"
        >
          <a
            (click)="openCommentsModal(item.esrCallComments)"
            class="text-blue cursor-pointer hover:underline"
            >View Full Comments</a
          >
        </div>
      </section>

      <ng-container
        *ngTemplateOutlet="specificObservations; context: { item: item }"
      >
      </ng-container>

      <ng-container
        *ngTemplateOutlet="fullCommentsInReport; context: { item: item }"
      >
      </ng-container>
    </section>

    <ng-container *ngTemplateOutlet="workOrderDetails; context: { item: item }">
    </ng-container>
  </section>
</ng-template>

<ng-template #trainingSessions let-item="item">
  <section class="collapsed-section flex w-full box-border min-h-14 max-h-fit">
    <ng-container
      *ngTemplateOutlet="serviceStatus; context: { item: item }"
    ></ng-container>

    <ng-container
      *ngTemplateOutlet="locationInformation; context: { item: item }"
    >
    </ng-container>

    <section class="service-details collapsed-item gap-1 w-[15%]">
      <div class="flex items-center gap-2">
        <span class="service-label">
          {{ (callType | serviceCallTypeLabel) + " - " + item.callReason }}
          <span *ngIf="isEMS(item)">&nbsp;(EMS)</span>
        </span>

        <img
          *ngIf="item.recurringIssues > 0"
          src="assets/service-insights/neptune-icon-black-recurring.svg"
          alt="Recurring Issue Icon"
        />

        <img
          *ngIf="item.virtualVisit > 0"
          src="assets/service-insights/neptune-icon-black-virtual-visit.svg"
          alt="Virtual Visit Icon"
        />
      </div>

      <div class="training-topic text-xs">
        <p>{{ item.trainingTopic }}</p>
      </div>

      <div
        class="flex items-center text-xs"
        *ngIf="!isEMS(item)"
        (click)="trackMixpanelEvent('See Notes')"
      >
        <a
          target="_blank"
          [href]="getWorkOrderUrl(item?.workOrderId)"
          class="flex items-center text-blue font-bold"
        >
          See Notes
          <img
            src="assets/shared-icons/neptune-icon-blue-chevron-right.svg"
            alt="See Notes"
            class="w-[14px] h-[14px]"
          />
        </a>
      </div>
    </section>

    <section class="participants collapsed-item gap-2 w-[10%]">
      <div
        class="flex flex-col justify-center items-center w-full box-border rounded-lg p-1 text-neptune-color-fg-muted bg-neptune-color-neutral-400 transition-all duration-100"
        [ngClass]="{
          'cursor-pointer hover:bg-blue hover:text-white':
            item.participants > 0,
        }"
        (click)="
          item.participants > 0
            ? openParticipantsModal(item.participantNames)
            : null
        "
      >
        <span class="findings-count text-sm font-bold">
          {{ item.participants ?? "0" }}
        </span>
        <span class="findings-unit text-xs">Participants</span>
      </div>
    </section>

    <ng-container
      *ngTemplateOutlet="photoThumbnails; context: { item: item }"
    ></ng-container>

    <ng-container *ngTemplateOutlet="infoToggle; context: { item: item }">
    </ng-container>
  </section>

  <section
    class="expanded-section w-full box-border p-6 flex justify-between bg-neptune-color-neutral-300 transition-all duration-300 ease-in-out"
    *ngIf="isRowExpanded(item.id)"
  >
    <ng-container
      *ngTemplateOutlet="accountInformation; context: { item: item }"
    >
    </ng-container>

    <section
      class="comments findings flex flex-col justify-start items-center gap-2 w-[30%]"
    >
      <div class="comment-section flex flex-col justify-start items-start">
        <p
          class="observationDetails text-xxs"
          *ngIf="item.callReason == 'RSC' || item.callReason == 'PRC'"
        >
          {{ item.observationName }} - {{ item.measurement }}
        </p>

        <div
          class="comments text-sm"
          *ngIf="hasComments(item); else noComments"
        >
          <span class="comments-title font-bold">Comments:</span>

          <!-- Comments based off call type for a session-->
          <ng-container [ngSwitch]="item.callReason">
            <ng-container *ngSwitchCase="'RSC'">
              <p class="call-comments" *ngIf="item.observationComments">
                {{ item.observationComments }}
              </p>
            </ng-container>

            <ng-container *ngSwitchCase="'PRC'">
              <p class="call-comments" *ngIf="item.observationComments">
                {{ item.observationComments }}
              </p>
            </ng-container>

            <ng-container *ngSwitchCase="'ESR'">
              <p class="call-comments" *ngIf="item.esrCallComments">
                {{ item.esrCallComments }}
              </p>
              <div *ngIf="isEMS(item)" class="full-comments-link">
                <a
                  (click)="openCommentsModal(item.esrCallComments)"
                  class="text-blue cursor-pointer hover:underline"
                >
                  View Full Comments
                </a>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'INST'">
              <p class="call-comments" *ngIf="item.installationCallComments">
                {{ item.installationCallComments }}
              </p>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="item.trainingCallComments">
            <p class="training-comments">
              {{ item.trainingCallComments }}
            </p>

            <div *ngIf="isEMS(item)" class="full-comments-link">
              <a
                (click)="openCommentsModal(item.trainingCallComments)"
                class="text-blue cursor-pointer hover:underline"
              >
                View Full Comments
              </a>
            </div>
          </ng-container>
        </div>

        <ng-template #noComments>
          <div class="comments text-sm">
            <span class="comments-title font-bold">Comments:</span>
            <p class="call-comments">No Comments</p>
          </div>
        </ng-template>
      </div>

      <ng-container
        *ngTemplateOutlet="fullCommentsInReport; context: { item: item }"
      ></ng-container>
    </section>

    <ng-container *ngTemplateOutlet="workOrderDetails; context: { item: item }">
    </ng-container>
  </section>
</ng-template>

<ng-template #quickCalls let-item="item">
  <section class="collapsed-section flex w-full box-border min-h-14 max-h-fit">
    <ng-container
      *ngTemplateOutlet="serviceStatus; context: { item: item }"
    ></ng-container>

    <ng-container
      *ngTemplateOutlet="locationInformation; context: { item: item }"
    >
    </ng-container>

    <section class="service-details collapsed-item gap-1 w-[15%]">
      <div class="flex items-center gap-2">
        <span class="service-label">
          {{ callType | serviceCallTypeLabel }}
          <span *ngIf="isEMS(item)">&nbsp;(EMS)</span>
        </span>

        <img
          *ngIf="item.recurringIssues > 0"
          src="assets/service-insights/neptune-icon-black-recurring.svg"
          alt="Recurring Issue Icon"
        />

        <img
          *ngIf="item.virtualVisit > 0"
          src="assets/service-insights/neptune-icon-black-virtual-visit.svg"
          alt="Virtual Visit Icon"
        />
      </div>

      <div
        class="flex items-center text-xs"
        *ngIf="!isEMS(item)"
        (click)="trackMixpanelEvent('See Notes')"
      >
        <a
          target="_blank"
          [href]="getWorkOrderUrl(item?.workOrderId)"
          class="flex items-center text-blue font-bold"
        >
          See Notes
          <img
            src="assets/shared-icons/neptune-icon-blue-chevron-right.svg"
            alt="See Notes"
            class="w-[14px] h-[14px]"
          />
        </a>
      </div>
    </section>

    <ng-container
      *ngTemplateOutlet="photoThumbnails; context: { item: item }"
    ></ng-container>

    <ng-container *ngTemplateOutlet="infoToggle; context: { item: item }">
    </ng-container>
  </section>

  <section
    class="expanded-section w-full box-border p-6 flex justify-between bg-neptune-color-neutral-300 transition-all duration-300 ease-in-out"
    *ngIf="isRowExpanded(item.id)"
  >
    <ng-container
      *ngTemplateOutlet="accountInformation; context: { item: item }"
    >
    </ng-container>

    <section
      class="comments flex flex-col justify-start items-center gap-2 w-[30%]"
    >
      <div class="comment-section flex flex-col justify-start items-start">
        <span class="comment-title text-sm font-bold">Comments</span>
        <p class="comment-content text-sm line-clamp-4">
          {{ item.quickCallComments }}
        </p>
      </div>

      <ng-container
        *ngTemplateOutlet="fullCommentsInReport; context: { item: item }"
      ></ng-container>
    </section>

    <ng-container *ngTemplateOutlet="workOrderDetails; context: { item: item }">
    </ng-container>
  </section>
</ng-template>

<!-- NOTE: Audit is the FRS/QSR equivalent of Program Reviews.
     All audit items are EMS calls. EMS-gated elements (See Notes,
     Full Comments in Report, View Report) are suppressed automatically. -->
<ng-template #audit let-item="item">
  <section class="collapsed-section flex w-full box-border min-h-14 max-h-fit">
    <ng-container
      *ngTemplateOutlet="serviceStatus; context: { item: item }"
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="locationInformation; context: { item: item }"
    ></ng-container>

    <section class="service-details collapsed-item gap-1 w-[15%]">
      <div class="flex items-center gap-2">
        <span class="service-label">
          {{ callType | serviceCallTypeLabel }}
        </span>
      </div>

      <div class="survey-name text-xs" *ngIf="item.surveyName">
        <p>{{ item.surveyName }}</p>
      </div>
    </section>

    <ng-container
      *ngTemplateOutlet="findingsBox; context: { item: item }"
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="photoThumbnails; context: { item: item }"
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="infoToggle; context: { item: item }"
    ></ng-container>
  </section>

  <section
    class="expanded-section w-full box-border p-6 flex justify-between bg-neptune-color-neutral-300 transition-all duration-300 ease-in-out"
    *ngIf="isRowExpanded(item.id)"
  >
    <ng-container
      *ngTemplateOutlet="accountInformation; context: { item: item }"
    ></ng-container>

    <section class="findings flex flex-col justify-start items-center w-[30%]">
      <ng-container
        *ngTemplateOutlet="generalObservations; context: { item: item }"
      ></ng-container>
      <ng-container
        *ngTemplateOutlet="specificObservations; context: { item: item }"
      ></ng-container>
    </section>

    <ng-container
      *ngTemplateOutlet="workOrderDetails; context: { item: item }"
    ></ng-container>
  </section>
</ng-template>

<ng-template #virtualAssistCalls let-item="item">
  <section class="collapsed-section flex w-full box-border min-h-14 max-h-fit">
    <ng-container
      *ngTemplateOutlet="serviceStatus; context: { item: item }"
    ></ng-container>

    <ng-container
      *ngTemplateOutlet="locationInformation; context: { item: item }"
    >
    </ng-container>

    <section class="service-details collapsed-item gap-1 w-[15%]">
      <div class="flex items-center gap-2">
        <span class="service-label">
          {{ item.siCallType | serviceCallTypeLabel }}
          <span *ngIf="isEMS(item)">&nbsp;(EMS)</span>
        </span>

        <img
          *ngIf="item.recurringIssues > 0"
          src="assets/service-insights/neptune-icon-black-recurring.svg"
          alt="Recurring Issue Icon"
        />

        <img
          *ngIf="item.virtualVisit"
          src="assets/service-insights/neptune-icon-black-virtual-visit.svg"
          alt="Virtual Visit Icon"
        />
      </div>

      <div
        class="flex items-center text-xs"
        *ngIf="!isEMS(item)"
        (click)="trackMixpanelEvent('See Notes')"
      >
        <a
          target="_blank"
          [href]="getWorkOrderUrl(item?.workOrderId)"
          class="flex items-center text-blue font-bold"
        >
          See Notes
          <img
            src="assets/shared-icons/neptune-icon-blue-chevron-right.svg"
            alt="See Notes"
            class="w-[14px] h-[14px]"
          />
        </a>
      </div>
    </section>

    <ng-container
      *ngTemplateOutlet="photoThumbnails; context: { item: item }"
    ></ng-container>

    <ng-container *ngTemplateOutlet="infoToggle; context: { item: item }">
    </ng-container>
  </section>

  <section
    class="expanded-section w-full box-border p-6 flex justify-between bg-neptune-color-neutral-300 transition-all duration-300 ease-in-out"
    *ngIf="isRowExpanded(item.id)"
  >
    <ng-container
      *ngTemplateOutlet="accountInformation; context: { item: item }"
    >
    </ng-container>

    <section
      class="findings comments flex flex-col justify-start items-center w-[30%]"
    >
      <section class="comments-section text-sm self-start">
        <span class="comments-title font-bold">Comments:</span>
        <p class="comments-content text-sm line-clamp-4">
          {{ item.virtualCallComments ?? "N/A" }}
        </p>
        <!--  -->
        <div
          *ngIf="isEMS(item) && item.virtualCallComments"
          class="full-comments-link"
        >
          <a
            (click)="openCommentsModal(item.virtualCallComments)"
            class="text-blue cursor-pointer hover:underline"
            >View Full Comments</a
          >
        </div>
      </section>

      <ng-container
        *ngTemplateOutlet="specificObservations; context: { item: item }"
      >
      </ng-container>

      <ng-container
        *ngTemplateOutlet="fullCommentsInReport; context: { item: item }"
      >
      </ng-container>
    </section>

    <ng-container *ngTemplateOutlet="workOrderDetails; context: { item: item }">
    </ng-container>
  </section>
</ng-template>


<!--
  Work order sections are consolidated into a shared template.

  Rationale:
  - All call types share the same overall work-order layout and behavior.
  - Variations are limited to a small set of call-type-specific fields.
  - This falls under the "minor deviation" exception to the template
    separation guideline, as the shared structure significantly outweighs
    the conditional content.
-->
<ng-template #workOrderDetails let-item="item">
  <section class="work-order flex flex-col self-start gap-4 w-[20%]">
    <div class="work-order-header">
      <span class="font-bold text-sm">Work Order :</span>&nbsp;

      <span
        *ngIf="item.pdfBaseUrl && item.pdfBaseUrl.trim() && !isEMS(item)"
        class="flex gap-2 items-center cursor-pointer text-blue"
        (click)="downloadWorkOrder(item.pdfBaseUrl)"
      >
        <span class="font-medium">View Report</span>

        <img
          class="w-5 h-5 self-center"
          src="assets/shared-icons/neptune-icon-blue-link-out.svg"
        />
      </span>
    </div>

    <div class="work-order-details flex flex-col">
      <ul class="mt-0 pl-5">
        <li>Ecolab Rep : {{ item.ecolabRep ?? "N/A" }}</li>

        <ng-container [ngSwitch]="callType">
          <!-- Installations -->
          <ng-container *ngSwitchCase="SICallTypes.Installations">
            <li *ngIf="!isEMS(item)">
              Training Performed :
              {{ item.trainingPerformed ? "Yes" : "No" }}
            </li>

            <li>
              Walk-Through :
              {{ item.walkthrough ? "With Manager" : "N/A" }}
            </li>
          </ng-container>

          <!-- Training -->
          <ng-container *ngSwitchCase="SICallTypes.TrainingSessions">
            <li *ngIf="!isEMS(item)">
              <div class="flex gap-1">
                <span>
                  Recurring Issues : {{ item.recurringIssues ?? "N/A" }}
                </span>

                <img
                  src="assets/service-insights/neptune-icon-black-recurring.svg"
                  alt="Recurring Issue Icon"
                  class="w-3 h-3 self-center"
                />
              </div>
            </li>

            <li>
              Manager in Attendance :
              {{ item.trainingManager ?? "N/A" }}
            </li>
          </ng-container>

          <ng-container *ngSwitchCase="SICallTypes.Audit">
            <li *ngIf="isEMS(item)">
              Duration :
              {{
                item.surveyDurationInMin != null
                  ? item.surveyDurationInMin + " min"
                  : "N/A"
              }}
            </li>
          </ng-container>

          <!-- Default -->
          <ng-container *ngSwitchDefault>
            <li *ngIf="!isEMS(item)">
              Training Performed :
              {{ item.trainingPerformed ? "Yes" : "No" }}
            </li>

            <li *ngIf="!isEMS(item)">
              <div class="flex gap-1">
                <span>
                  Recurring Issues : {{ item.recurringIssues ?? "N/A" }}
                </span>

                <img
                  src="assets/service-insights/neptune-icon-black-recurring.svg"
                  alt="Recurring Issue Icon"
                  class="w-3 h-3 self-center"
                />
              </div>
            </li>
          </ng-container>
        </ng-container>
      </ul>
    </div>
  </section>
</ng-template>

<!--
  Shared templates used across all service call types.

  These fragments are reused **verbatim** across call type templates and are
  expected to maintain consistent styling, layout, and behavior. Extracted
  into reusable ng-templates to reduce duplication and centralize maintenance
  of common UI sections without introducing additional component boundaries.

  If a call type requires divergent content, behavior, or layout:
  - Avoid introducing ngIf/ngSwitch ladders within these shared templates.
  - For functionality specific to a single call type, keep the implementation
    within that call type's template.
  - If multiple call types share a new variant, evaluate creating a separate
    reusable template rather than expanding conditional rendering logic.
-->
<ng-template #serviceStatus let-item="item">
  <section class="service-status collapsed-item gap-2 w-[15%]">
    <div class="status flex gap-2 text-sm">
      <img
        alt="Service Status"
        src="assets/service-insights/neptune-icon-green-service-status.svg"
      />
      <span class="status-text">{{ item?.status }}</span>
    </div>
    <time class="date text-xs text-neptune-default">
      {{ item?.endDate | date: "longDate" }}
    </time>
  </section>
</ng-template>

<ng-template #locationInformation let-item="item">
  <section class="location-information collapsed-item gap-1 w-[20%]">
    <span class="location-name flex-wrap" title="{{ item?.accountName }}">
      {{ item?.accountName | titlecase }}
    </span>
    <span class="location-address text-xs text-neptune-default">
      {{ item?.shippingCity | titlecase }}, {{ item?.shippingState }}
    </span>
  </section>
</ng-template>

<ng-template #findingsBox let-item="item">
  <section class="findings collapsed-item gap-2 w-[10%]">
    <div
      class="flex flex-col justify-center items-center w-full box-border rounded-lg p-1 text-neptune-color-fg-muted bg-neptune-color-neutral-400"
    >
      <span class="findings-count text-sm font-bold">
        {{ item.totalRowCount ?? "N/A" }}
      </span>
      <span class="findings-unit text-xs">{{ rowUnits }}</span>
    </div>
  </section>
</ng-template>

<ng-template #photoThumbnails let-item="item">
  <section class="photo collapsed-item gap-1 w-[35%]">
    <div
      class="thumbnail-grid flex gap-2 justify-start items-center"
      *ngIf="item.photoInfo.length > 0"
    >
      <div
        *ngFor="let photo of item.photoInfo.slice(0, 5); let photoIndex = index"
        class="thumbnail relative"
        id="{{ item.workOrderId }}-{{ photoIndex }}"
        (click)="openPhotoInNewTab(item)"
      >
        <img
          [src]="photo.url"
          alt="{{ photo.description }}"
          class="w-10 h-10 object-cover"
          [class.opacity-40]="photoIndex === 4 && item.photoInfo.length > 5"
        />
        <div
          *ngIf="photoIndex === 4 && item.photoInfo.length > 5"
          class="absolute inset-0 flex items-center justify-center bg-black/30 text-white text-sm w-10 h-10"
        >
          +{{ item.photoInfo.length - 5 }}
        </div>
      </div>
    </div>
    <span *ngIf="item.photoInfo.length === 0" class="no-photos text-xxs">
      No Photos available
    </span>
  </section>
</ng-template>

<ng-template #infoToggle let-item="item">
  <section
    class="info flex items-center gap-2 p-4 w-[5%] text-blue"
    (click)="toggleArrow(item.id)"
  >
    <span>Info</span>
    <img
      src="assets/shared-icons/neptune-icon-blue-chevron-down.svg"
      class="expand-row-icon transition-all duration-300"
      alt="Expand Row Icon"
      [ngClass]="isRowExpanded(item.id) ? 'transform rotate-180' : ''"
    />
  </section>
</ng-template>

<ng-template #accountInformation let-item="item">
  <section class="account-information flex flex-col justify-start w-[20%]">
    <span class="text-sm font-bold">Account Information:</span>
    <ul class="text-sm pl-5">
      <li class="address">
        Address : {{ item?.shippingStreet }}, {{ item?.shippingCity }},
        {{ item?.shippingState }} {{ item?.shippingPostalCd }},
        {{ item?.shippingCountry }}
      </li>
      <li class="account-number">Account Number : {{ item.accountNumber }}</li>
    </ul>
  </section>
</ng-template>

<ng-template #generalObservations let-item="item">
  <section class="general text-sm self-start">
    <span class="font-bold">General {{ rowUnits }}:</span>
    <ul class="mt-0 pl-5">
      <li>
        Front of House:
        <span
          [ngClass]="
            item.frontOfHouse === 'Issue Found'
              ? 'text-neptune-color-orange-500'
              : 'text-neptune-color-yellow-500'
          "
        >
          {{ item.frontOfHouse ?? "N/A" }}
        </span>
      </li>

      <li>
        Back of House:
        <span
          [ngClass]="
            item.backOfHouse === 'Issue Found'
              ? 'text-neptune-color-orange-500'
              : 'text-neptune-color-yellow-500'
          "
        >
          {{ item.backOfHouse ?? "N/A" }}
        </span>
      </li>
    </ul>
  </section>
</ng-template>

<ng-template #specificObservations let-item="item">
  <section
    class="specific text-sm self-start"
    *ngIf="item.specificObs.length > 0"
  >
    <span class="font-bold">Specific {{ rowUnits }}:</span>
    <ul class="mt-0 pl-5">
      <li *ngFor="let obs of item.specificObs | slice: 0 : 3">
        {{ obs }}
      </li>
    </ul>
  </section>
</ng-template>

<ng-template #fullCommentsInReport let-item="item">
  <div
    class="full-report-link self-start text-sm"
    *ngIf="!isEMS(item)"
    (click)="trackMixpanelEvent('Full comments in report')"
  >
    <a
      target="_blank"
      class="text-blue"
      [href]="getWorkOrderUrl(item?.workOrderId)"
    >
      Full comments in report
    </a>
  </div>
</ng-template>

<!-- Skeleton Loaders -->
<ng-template #skeletonLoaderToolbar>
  <section id="skeletonLoaderToolbar" class="flex flex-col gap-2 animate-pulse">
    <div class="flex justify-between items-center">
      <div class="h-10 w-[150px] bg-neptune-subtle rounded"></div>
      <div class="h-10 w-[250px] bg-neptune-subtle rounded"></div>
    </div>

    <div class="h-12 w-full bg-neptune-subtle rounded"></div>
  </section>
</ng-template>

<ng-template #skeletonLoaderTable>
  <section
    id="serviceDetailsTableSkeletonLoader"
    class="flex flex-col gap-4 animate-pulse"
  >
    <div *ngFor="let group of [1, 2, 3, 4]" class="flex flex-col gap-1">
      <!-- Group Header -->
      <div class="h-14 w-full rounded-lg bg-neptune-subtle"></div>

      <!-- One Collapsed Row -->
      <section class="flex items-center w-full min-h-14 p-4 bg-white rounded-lg box-border">
        <!-- Status -->
        <div class="w-[15%] flex flex-col gap-2">
          <div class="h-4 w-20 rounded bg-neptune-subtle"></div>
          <div class="h-3 w-24 rounded bg-neptune-subtle"></div>
        </div>

        <!-- Location -->
        <div class="w-[20%] flex flex-col gap-2">
          <div class="h-4 w-36 rounded bg-neptune-subtle"></div>
          <div class="h-3 w-28 rounded bg-neptune-subtle"></div>
        </div>

        <!-- Service Details -->
        <div class="w-[15%] flex flex-col gap-2">
          <div class="h-4 w-32 rounded bg-neptune-subtle"></div>
          <div class="h-3 w-20 rounded bg-neptune-subtle"></div>
        </div>

        <!-- Findings -->
        <div class="w-[10%] flex justify-center">
          <div class="h-10 w-14 rounded-lg bg-neptune-subtle"></div>
        </div>

        <!-- Photos -->
        <div class="w-[35%] flex gap-2">
          <div class="w-10 h-10 rounded bg-neptune-subtle"></div>
          <div class="w-10 h-10 rounded bg-neptune-subtle"></div>
          <div class="w-10 h-10 rounded bg-neptune-subtle"></div>
        </div>

        <!-- Info -->
        <div class="w-[5%] flex justify-center">
          <div class="h-4 w-8 rounded bg-neptune-subtle"></div>
        </div>
      </section>
    </div>
  </section>
</ng-template>
